// extracted by mini-css-extract-plugin
export default {"logo_slider_container":"logos_logo_slider_container__oWUzP","logos_scroll":"logos_logos_scroll__4m4gp","scroll-marquee":"logos_scroll-marquee__H1ZbN"};